import { Controller } from '@hotwired/stimulus'
import { createConsumer } from '@rails/actioncable'

export default class extends Controller {
  static values = {
    broadcastId: String,
    tableId: String
  }

  get subscriptionParams() {
    const channel = 'V2::BatchActionsChannel'

    return {
      channel: channel,
      broadcast_id: this.broadcastIdValue
    }
  }

  connect() {
    this.subscribeToChannel()
  }

  subscribeToChannel() {
    createConsumer().subscriptions.create(this.subscriptionParams, {
      received: data => {
        this.handleChannelBroadcast(data)
      }
    })
  }

  handleChannelBroadcast(data) {
    const event = data.event
    const selectedItemsIds = data.selected_items_ids

    switch (event) {
      case 'refresh_table':
        this.reloadTableTurboFrame(selectedItemsIds)
        this.closeDialogs()
        break
    }
  }

  reloadTableTurboFrame(selectedItemsIds) {
    const tableTurboFrameId = this.tableIdValue
    const frame = document.getElementById(tableTurboFrameId)
    this.setSelectedActivityDataParams(frame, selectedItemsIds)

    frame.reload()
  }

  closeDialogs() {
    const dialogs = document.querySelectorAll('dialog')
    dialogs.forEach(dialog => {
      if (dialog.open) {
        dialog.remove()
      }
    })
    const sharedModal = document.querySelector('turbo-frame#modal-shared-frame')
    sharedModal.innerHTML = ''
  }

  setSelectedActivityDataParams(frame, selectedItemsIds) {
    if (!selectedItemsIds) return
    // If the number of IDs exceeds 1000, the IDs are not passed as parameters to avoid exceeding the URL length limit.
    if (selectedItemsIds.length > 1000) return

    const domain = window.location.origin
    const url = new URL(domain + frame.src)
    const params = new URLSearchParams(frame.src)
    params.set('selected_items_ids', selectedItemsIds.join(','))
    url.search = params.toString()
    frame.src = url.pathname + url.search
  }
}
